export default __webpack_public_path__ + "static/media/end-destination.d94a88dd.svg";